import type { HeroSplitData } from './schema';

export function HeroSplitRenderer(props: HeroSplitData) {
  const {
    eyebrow,
    h1,
    highlight,
    sub,
    ctaPrimary,
    ctaSecondary,
    image,
    imageAlt,
    reverse,
    theme,
  } = props;

  return (
    <section className={`v5-ph v5-ph-split v5-ph-${theme}${reverse ? ' v5-ph-reverse' : ''}`}>
      <div className="v5-ph-split-inner">
        <div className="v5-ph-split-text">
          {eyebrow ? <p className="v5-ph-eyebrow">{eyebrow}</p> : null}
          <h1 className="v5-ph-h1">
            {h1}
            {highlight ? <span className="v5-ph-highlight"> {highlight}</span> : null}
          </h1>
          {sub ? <p className="v5-ph-sub">{sub}</p> : null}
          {(ctaPrimary || ctaSecondary) && (
            <div className="v5-ph-ctas">
              {ctaPrimary ? (
                <a className="v5-btn v5-btn-primary" href={ctaPrimary.href}>
                  {ctaPrimary.label}
                </a>
              ) : null}
              {ctaSecondary ? (
                <a className="v5-btn v5-btn-ghost" href={ctaSecondary.href}>
                  {ctaSecondary.label}
                </a>
              ) : null}
            </div>
          )}
        </div>
        <div className="v5-ph-split-image">
          <img src={image} alt={imageAlt} loading="eager" />
        </div>
      </div>
    </section>
  );
}
